package oldcomponents.triggers

import oldcomponents.Draggable
import ru.it_mozaika.sender.js.application.format
import js.core.jso

import kotlinx.css.*
import kotlinx.css.properties.*
import kotlinx.html.I
import kotlinx.html.classes
import kotlinx.html.draggable
import kotlinx.html.id
import kotlinx.html.js.*
import org.w3c.dom.HTMLDivElement
import react.*
import react.dom.*
import react.dom.svg.ReactSVG.circle
import ru.it_mozaika.sender.common.models.*
import styled.*
import kotlin.Float
import kotlin.time.ExperimentalTime

val connector = fc<ConnectorProps> { props ->
//    var isHover by useState(false)
//    var isSelected by useState(false)

    styledDiv {
        css {
            transition(duration = 0.1.s, timing = Timing.materialStandard)
            transform {
                scale(
                    when {
                        props.isSelected -> 1.35f
//                        isHover -> 1.2f
                        else -> 1.0f
                    }
                )
            }
            width = 24.px
            height = 24.px
            backgroundColor = Color.transparent

//            hover {
//                if (!props.isSelected) {
//                    transform {
//                        scale(1.2f)
//                    }
//                }
//            }
        }
        attrs {
//            if (props.canBeSelected) {
                draggable = kotlinx.html.Draggable.htmlFalse
//                onMouseDownFunction = {
//                    (it.target as? HTMLDivElement)?.let { element ->
//                        val selected = !isSelected
//                        if (selected) {
//                            val x =
//                                (element.getBoundingClientRect().left + element.getBoundingClientRect().width / 2).toFloat()
//                            val y =
//                                (element.getBoundingClientRect().bottom + element.getBoundingClientRect().height / 2).toFloat()
//                            props.onConnectorSelected(x, y)
//                        }
//                        isSelected = selected
//                    }
//                }
                onClickFunction = {
                    (it.target as? HTMLDivElement)?.let { element ->

                        val x =
                            ((element.parentElement as? HTMLDivElement)?.offsetLeft ?: 0) + (element.offsetLeft + element.getBoundingClientRect().width / 2).toFloat()
                        val y =
                            ((element.parentElement as? HTMLDivElement)?.offsetTop ?: 0) + (element.offsetTop + element.getBoundingClientRect().height / 2).toFloat()
                        if (undefined != props.onConnectorSelected) {
                            props.onConnectorSelected(x, y)
                        }
                    }
                }
//            }
//                onMouseMoveFunction = {
//                    println("onMouseMove")
//                }
//
//                onDragFunction = {
//                    println("onDragFunction")
//                }
//                onDragStartFunction = {
//                    println("onDragStart")
//                }
//                onDragEndFunction = {
//                    println("onDragEndFunction")
//                }
        }
        styledSvg {
            css {
                pointerEvents = PointerEvents.none
                userSelect = UserSelect.none
                put("-webkit-user-select", "none")
                put("-khtml-user-select", "none")
                put("-oz-user-select", "none")
                put("-o-user-select", "none")
                put("-ms-user-select", "none")
                put("-webkit-user-drag", "none")
                put("-khtml-user-drag", "none")
                put("-moz-user-drag", "none")
                put("-o-user-drag", "none")
                put("-ms-user-drag", "none")
                put("user-drag", "none")
                width = 25.px
                height = 25.px
            }
            attrs.draggable = kotlinx.html.Draggable.htmlFalse
            child(
                createElement(
                    circle,
                    jso {
                        cx = 12.0
                        cy = 12.0
                        r = 10.0
                        stroke = "white"
                        strokeWidth = 4.0
                        fill = if (props.isSelected) "#007D96" else "#A2CDCD"
                    }
                )
            )
        }
    }
}

external interface SvgCircleProps : Props {
    var cx: Int
    var cy: Int
    var r: Int
    var stroke: String
    var fill: String
    var strokeWidth: Int
}

external interface ConnectorProps : Props {
    var onConnectorSelected: (x: Float, y: Float) -> Unit
    var isSelected: Boolean

//    val x: Number
//    val y: Number
}

external interface TriggerBlockProps : Props {
    var width: Float
    var height: Float

    var stats: TriggerStepStatistics?
    var showStats: Boolean
    var step: TriggerStep
    var expand: Boolean
    var onExpandChange: (Boolean) -> Unit
    var position: TriggerStepPosition
    var move: (x: Float, y: Float) -> Unit

    var connectorSelected: (id: Int, x: Float, y: Float) -> Unit // -1 - input connector; 0..infinity - output connector
    var selectedConnector: Int

    var onHover: (Boolean) -> Unit
    var onStartDrag: () -> Unit
    var isDragging: Boolean
    var zIndex: Int

    var onEdit: () -> Unit
    var onDelete: () -> Unit
}


@OptIn(ExperimentalTime::class)
val triggerBlockComponent = fc<TriggerBlockProps> { props ->
    var isHover by useState(false)
//    var isExpand by useState(true)

    var positionX by useState(props.position.x * props.width)
    var positionY by useState(props.position.y * props.height)

    useEffect(props.width, props.height, props.position.x, props.position.y) {
//        println("1ж ${props.step.id} ${props.position}")
        positionX = props.position.x * props.width
        positionY = props.position.y * props.height
    }

    var blockIcon by useState("")
    var blockColor by useState("")
    var outConnectorsCount by useState(2)
    var blockTitle by useState("")
    useEffect(props.step.type) {
        blockTitle = when (props.step.type) {
            is TriggerStepType.StartTriggerStep -> {
                blockIcon = "la la-play-circle"
                blockColor = "#fe195e"
                outConnectorsCount = 1
                "Старт серии"
            }
            is TriggerStepType.TargetTriggerStep -> {
                blockIcon = "la la-check-circle-o"
                blockColor = "#31b0d5"
                outConnectorsCount = 0
                "Цель"
            }
            is TriggerStepType.FilterTriggerStep -> {
                blockIcon = "la la-filter"
                blockColor = "#f0ad4e"
                "Фильтр"
            }
            is TriggerStepType.EmailTriggerStep -> {
                blockIcon = "la la-envelope-o"
                blockColor = "#5cb85c"
                "E-mail"
            }
            is TriggerStepType.ConditionTriggerStep -> {
                blockIcon = "la la-balance-scale"
                blockColor = "#fe195e"
                "Условие"
            }
            is TriggerStepType.ActionTriggerStep -> {
                blockIcon = "la la-cogs"
                blockColor = "#5d5386"
                "Действие"
            }

            else -> {""}
        }
    }

    var blockHeight by useState(0.px)
    useEffect(props.expand, isHover) {
        if (!props.isDragging) {
            blockHeight = if (props.expand || isHover) 200.px else 48.px
        }
    }

    Draggable {
        attrs.position = jso {
            x = positionX
            y = positionY
        }
        attrs.onDrag = { _, data ->
            positionX += data.deltaX
            positionY += data.deltaY
        }
        attrs.onStart = { _, _ ->
            props.onStartDrag()
        }
        attrs.onStop = { e, data ->
            props.move(data.x, data.y)
        }
//        attrs.handle = "#header${props.step.id}"
        attrs.handle = "#ic_move_${props.step.id}"
        attrs.allowAnyClick = true

//        attrs.onStart ={ _, _ -> println("onStart")}

        div {
            attrs.id = "step_${props.step.id}"
            attrs.jsStyle {
                position = "relative"
                zIndex = props.zIndex
            }
            attrs.onMouseOutFunction = {
                if (isHover && !props.isDragging) {
                    props.onHover(false)
                    isHover = false
                }
            }
            attrs.onMouseOverFunction = {
                if (!isHover && !props.isDragging) {
                    props.onHover(true)
                    isHover = true
                }
            }
            styledDiv {
                css {
                    userSelect = UserSelect.none
                    backgroundColor = Color.black.withAlpha(0.25)
                    width = 40.px
                    paddingLeft = 5.px
                    minHeight = 48.px
                    position = kotlinx.css.Position.absolute
                    top = 8.px
                    left = 220.px
                    zIndex = 0
                    transition(duration = 0.5.s)
                    transform {
//                            translate(0.px)
                        translate(if (isHover) 30.px else 0.px)
                    }
                    opacity = if (isHover) 1 else 0
//                        hover {
//                            transform {
//                                translate(65.px)
//                            }
//                        }
                }
                styledDiv {
                    attrs.classes = setOf("col")
                    css {
                        paddingLeft = 0.px
                        paddingRight = 0.px
                    }

                    fun RBuilder.renderIcon(icon: String, cursor: Cursor = Cursor.pointer, block: StyledDOMBuilder<I>.() -> Unit) {
                        styledI {
                            attrs.classes = setOf(icon)
                            css {
                                this.cursor = cursor
                                color = Color.white
                                alignSelf = Align.center
                                transition("all", 0.4.s, Timing.ease)
                                padding(0.5.rem)
                                borderRadius = 50.pct
                                fontSize = 1.5.rem
                            }
                            block()
                        }
                    }

                    renderIcon("la la-arrows", Cursor.move) {
                        attrs.id = "ic_move_${props.step.id}"
                    }
                    renderIcon("la la-pencil") {
                        attrs.onClickFunction = {
                            props.onEdit()
                        }
                    }
                    renderIcon("la la-trash-o") {
                        attrs.onClickFunction = {
                            props.onDelete()
                        }
                    }
                }
            }
            styledDiv {
//            attrs.jsStyle {
//                transf
//            }
                if (props.step.type !is TriggerStepType.StartTriggerStep) {
                    styledDiv {
                        attrs.classes = setOf("row d-flex justify-content-around")
                        css {
                            position = kotlinx.css.Position.absolute
                            top = (-14).px
                            left = 15.px
                            width = 100.pct
                            zIndex = 10
                        }
                        connector {
                            attrs.onConnectorSelected = { x, y ->
                                props.connectorSelected(-1, x, y)
                            }
//                            attrs.canBeSelected = false
//                            attrs.onConnectorSelected = { a, b ->
//                                println("$a $b")
//                            }
                        }
                    }
                }
                styledDiv {
                    attrs.classes = setOf("row d-flex justify-content-around")
                    css {
                        position = kotlinx.css.Position.absolute
                        bottom = (-14).px
                        left = 15.px
                        width = 100.pct
                        zIndex = 10
                    }
                    for (i in 0 until outConnectorsCount) {
                        connector {
//                            attrs.canBeSelected = true
                            attrs.onConnectorSelected = { x, y ->
                                props.connectorSelected(i, x, y)
                            }
                            attrs.isSelected = props.selectedConnector == i
                        }
                    }
                }
                attrs.classes = if (isHover) setOf("widget", "has-shadow") else setOf("widget")
                css {
                    width = 250.px
                    minHeight = 48.px
                    height = blockHeight
                    position = kotlinx.css.Position.absolute
                    transition("height", 0.4.s, Timing.ease)
                    userSelect = UserSelect.none
                }

                styledDiv {
//                attrs.classes = setOf("row", "flex-row", "align-middle")
                    attrs.id = "header${props.step.id}"
                    css {
                        width = 100.pct
                        height = 48.px
                        backgroundColor = Color(blockColor)
                        color = Color.white
                        fontWeight = FontWeight.w600
//                        cursor = Cursor.move
                        padding(6.px)
                    }
                    styledA("#") {
                        css.verticalAlign = VerticalAlign.middle
                        css.marginRight = 6.px
                        attrs.onClickFunction = {
                            it.preventDefault()
                            it.stopPropagation()
                            props.onExpandChange(!props.expand)
                        }
                        styledI {
                            attrs.classes = setOf("la la-angle-down")
                            css {
                                color = Color.white
                                alignSelf = Align.center
                                transition("all", 0.4.s, Timing.ease)
                                padding(0.5.rem)
                                borderRadius = 50.pct
                                fontSize = 1.5.rem
//                                hover {
//                                    backgroundColor = Color.white.withAlpha(0.85)
//                                    color = Color.black
//                                }
                            }
                            attrs.jsStyle {
                                if (props.expand) {
                                    transform = "rotate(-180deg)"
                                }
                            }
                        }
                    }

                    styledI {
                        attrs.classes = setOf(blockIcon)
                        css {
                            color = Color.white
                            alignSelf = Align.center
                            fontWeight = FontWeight.w600
                            fontSize = 1.5.rem
                            verticalAlign = VerticalAlign.middle
                        }
                    }
                    styledSpan {
                        css {
                            marginLeft = 4.px
                            verticalAlign = VerticalAlign.middle
                        }
                        +blockTitle
                    }
                }


                if (props.expand || isHover) {
                    if (!props.showStats) {
                        if (props.step.type !is TriggerStepType.StartTriggerStep && props.step.type !is TriggerStepType.TargetTriggerStep) {
                            styledSpan {
                                css {
                                    padding(8.px)
                                    wordWrap = WordWrap.breakWord
                                    maxWidth = 250.px
                                    color = Color.black
                                }
                                i("la la-clock-o") {}
                                +if (props.step.delay <= 0L && props.step.randomDelay <= 0L) {
                                    "Выполнить без задержки"
                                } else {
                                    fun delayText(value: Long): String {
                                        return when {
                                            value > 86_400L -> "${(value / 86_400.0f).format(2)} дн."
                                            value > 3_600L -> "${(value / 3_600.0f).format(2)} ч."
                                            value > 60L -> "${(value / 60.0f).format(2)} м."
                                            else -> "$value с."
                                        }
                                    }
                                    val randomDelayText = if (props.step.randomDelay > 0L) {
                                        " (+0 .. ${delayText(props.step.randomDelay)})"
                                    } else {
                                        ""
                                    }
                                    "Выполнить через ${delayText(props.step.delay)}${randomDelayText}"
                                }
                            }
                        }

                        styledSpan {
                            css {
                                padding(8.px)
                                wordWrap = WordWrap.breakWord
                                maxWidth = 250.px
                                color = Color.black
                            }
                            +getTriggerDescription(props.step.type)
                        }
                    } else {
                        props.stats?.let { stats ->
                            styledSpan {
                                css {
                                    padding(8.px)
                                    wordWrap = WordWrap.breakWord
                                    maxWidth = 250.px
                                    color = Color.black
                                }
                                +"Количество выполнений: ${stats.invokeCount}"
                            }
                            when (val typed = stats.typedStats) {
                                is TriggerTypedStepStatistics.ConditionStepStatistics -> {
                                    styledSpan {
                                        css {
                                            padding(8.px)
                                            wordWrap = WordWrap.breakWord
                                            maxWidth = 250.px
                                            color = Color.black
                                        }
                                        +"Да: ${typed.trueInvokedCount}"
                                    }
                                    styledSpan {
                                        css {
                                            padding(8.px)
                                            wordWrap = WordWrap.breakWord
                                            maxWidth = 250.px
                                            color = Color.black
                                        }
                                        +"Нет: ${stats.invokeCount - typed.trueInvokedCount}"
                                    }
                                }
                                is TriggerTypedStepStatistics.EmailStepStatistics -> {
                                    listOf(
                                        "Отправлено: ${typed.send}",
                                        "Доставлено: ${typed.delivery}",
                                        "Прочитано: ${typed.read}",
                                        "Клик: ${typed.click}",
                                    ).forEach {
                                        styledSpan {
                                            css {
                                                padding(8.px)
                                                wordWrap = WordWrap.breakWord
                                                maxWidth = 250.px
                                                color = Color.black
                                            }
                                            typed.send
                                            +it
                                        }
                                    }
                                }
                                null -> {}
                                else -> {}
                            }
                        }
                    }
                }
                props.stats?.let { stats ->
//                styledDiv {
//                    css {
//                        backgroundColor = Color.black.withAlpha(0.1)
//                        minWidth = 170.px
////                    minHeight = 50.px
//                        position = Position.absolute
//                        top = 10.px
//                        right = 0.px
//                        zIndex = 0
//                        transition(duration = 0.5.s)
//                        transform {
//                            translate(if (state.isHover) 65.px else 0.px)
//                        }
//                    }
//
//                    mFade(!state.isHover) {
//                        mGridContainer(MGridSpacing.spacing1, alignItems = MGridAlignItems.flexEnd) {
//                            attrs.direction = MGridDirection.column
//                            css {
//                                position = Position.absolute
//                                top = 5.px
//                                right = 5.px
//                                minWidth = 100.px
//                            }
//                            mGridItem {
//                                mGridContainer(MGridSpacing.spacing1, justify = MGridJustify.spaceBetween, wrap = MGridWrap.noWrap) {
//                                    mGridItem {
//                                        mIcon("done_all")
//                                    }
//                                    mGridItem {
//                                        mTypography("200")
//                                    }
//                                }
//                            }
//                        }
//                    }
//                    mFade(state.isHover) {
//                        mGridContainer(MGridSpacing.spacing1) {
//                            attrs.direction = MGridDirection.column
//                            css {
//                                position = Position.absolute
//                                top = 5.px
//                                right = 5.px
//                                width = 130.px
//                            }
//                            mGridContainer(MGridSpacing.spacing1, wrap = MGridWrap.noWrap) {
//                                mGridItem {
//                                    mTypography("Выполнено:")
//                                }
//                                mGridItem {
//                                    mTypography(stats.invokeCount.toString())
//                                }
//                            }
//                        }
//                    }
//                }
                }

//            if (props.step.type !is TriggerStepType.StartTriggerStep)
//                renderConnectors()
//            if (props.step.type !is TriggerStep.TargetTriggerStep) {
//                renderConnectors(false, outConnectorsCount)
//            }



//            mCard(state.isHover) {
//                css {
//                    marginRight = 5.px
//                    width = 220.px
//                    maxHeight = 350.px
//                    zIndex = 10
//                    position = Position.absolute
//                }
//                mCardHeader(blockTitle, avatar = mIcon(blockIcon, addAsChild = false), className = "blockHeader") {
//                    css {
//                        backgroundColor = Color(blockColor)
//                        fontWeight = FontWeight.w700
//                        color = Color.white
//                    }
//                    attrs.disableTypography = true
//                    attrs.action = mIconButton(if (state.isExpand) "expand_less" else "expand_more", color = MColor.inherit, onClick = {
//                        setState { isExpand = !isExpand }
//                    }) {
//                        css.color = Color.white
//                    }
//                }
//                mCollapse(state.isExpand, timeout = SimpleTransitionDuration(400)) {
//                    mCardContent {
//                        styledDiv {
//                            css {
//                                width = 100.pct
//                                height = 50.px
//                            }
//                        }
//                    }
//                }
//            }
            }
        }

    }
}

private fun getTriggerDescription(type: TriggerStepType): String {
    return when (type) {
        is TriggerStepType.StartTriggerStep, -> {
            when (val event = type.event) {
                is TriggerEvent.AddSubscriber -> "Добавление подписчика в любой из ${event.subscriptionListIds.size} списков"
                TriggerEvent.AbandonedBasket -> "Брошенная корзина"
                TriggerEvent.BasketProductPriceDrop -> "Снижена цена на товары из корзины"
                TriggerEvent.ProductsReturnToStore -> "Товар появился в продаже"
                TriggerEvent.Order -> "Заказ"
                else -> {""}
            }
        }
        is TriggerStepType.TargetTriggerStep -> {
            type.title
        }
        is TriggerStepType.FilterTriggerStep -> {
            "Выполнены условия"
        }
        is TriggerStepType.EmailTriggerStep -> {
            "Тема: ${type.subject}"
        }
        is TriggerStepType.ConditionTriggerStep -> {
            when (val event = type.event) {
                is TriggerEvent.AddSubscriber -> "Добавление подписчика в любой из ${event.subscriptionListIds} списков"
                TriggerEvent.AbandonedBasket -> "Брошенная корзина"
                TriggerEvent.BasketProductPriceDrop -> "Снижена цена на товары из корзины"
                TriggerEvent.ProductsReturnToStore -> "Товар появился в продаже"
                TriggerEvent.Order -> "Заказ"
            }
        }
        is TriggerStepType.ActionTriggerStep -> {
            when (val action = type.action) {
                is TriggerAction.Subscribe -> "Подписать на списки (${action.lists.size} шт.)"
                is TriggerAction.Unsubscribe -> "Отписать от списков (${action.lists.size} шт.)"
                is TriggerAction.SendEmail -> "Отправить сообщение на почту ${action.email}"
                is TriggerAction.Separate -> "Разделить на две части в соотношении ${action.percent}/${100-action.percent}"
                is TriggerAction.HttpRequest -> "Отправить HTTP запрос: ${action.url}"
                else -> {""}
            }
        }
    }
}